import { Avatar, Flexbox } from '@/components'
import { clinicalCareStatus, clinicalCareStatusClasses } from '@/constants/clinicalCares'
import dateMask from '@/lib/masks/date'
import { isBefore } from 'date-fns'
import PropTypes from 'prop-types'
import React from 'react'

function ClinicalCareCard({ clinicalCare, hideLateMessage }) {
  const { animal, priority } = clinicalCare

  return (
    <div className="panel">
      <div className="panel-header">
        <Flexbox.Columns className="align-center col-gapless">
          <Flexbox.Column className="col-auto mr-1">
            <Avatar name={animal?.name} photoURL={animal?.photoURL} avatarSize="sm" />
          </Flexbox.Column>
          <Flexbox.Column>
            <div className="panel-title h6">
              {animal?.name}
            </div>
          </Flexbox.Column>
        </Flexbox.Columns>
      </div>
      <div className="panel-body">
        {
          !hideLateMessage && isBefore(new Date(clinicalCare?.scheduledTo), new Date()) && (
            <div className="text-error mb-2">
              <small>Este atendimento está atrasado!</small>
            </div>
          )
        }
        <div>
          <small>Agendado para: <b>{dateMask(clinicalCare?.scheduledTo)}</b></small>
        </div>
        <div>
          <small>Status:
            <b className={clinicalCareStatusClasses[clinicalCare.status]}>
              &nbsp;{clinicalCareStatus[clinicalCare.status]}
            </b>
          </small>
        </div>
      </div>
      <div className="panel-footer">
        <Flexbox.Columns className="align-center">
          <Flexbox.Column>
            {
              Boolean(priority) && (
                <small className="chip text-light chip" style={{ backgroundColor: priority?.color }}>
                  {priority?.title}
                </small>
              )
            }
          </Flexbox.Column>
          <Flexbox.Column className="col-auto">
            <a href={`/app/clinical-cares/status/${clinicalCare?.status || 'all'}/${clinicalCare.id}`} className="c-hand text-small">
              <i className="fas fa-eye" />
              &nbsp;Ver detalhes
            </a>
          </Flexbox.Column>
        </Flexbox.Columns>
      </div>
    </div>
  )
}

ClinicalCareCard.propTypes = {
  clinicalCare: PropTypes.objectOf(Object).isRequired,
  hideLateMessage: PropTypes.bool,
}

ClinicalCareCard.defaultProps = {
  hideLateMessage: false,
}

export default ClinicalCareCard
